import logo from "../../public/Assets/site_logo.png";
import { Link } from "react-router-dom";
import { useState } from "react";
import useOnlineStatus from "../utils/useOnlineStatus";
import { useSelector } from "react-redux";
import { addItem } from "../utils/cartSlice";
import { useDispatch } from "react-redux";

const Header = () => {
  const [toggler, useToggle] = useState("Log in");
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const toggle = () => {
    toggler == "Log in" ? useToggle("Log out") : useToggle("Log in");
  };
  const cartItems = useSelector((store) => store.cart.items);
  const dishData = useSelector((store) => store.dish.data);
  const onlineStatus = useOnlineStatus();
  const ShowHamburger = () => {
    setShow(!show);
    console.log(show);
  };
  return (
    <header>
      <nav className="bg-gray-800 border-gray-200 px-4 lg:px-6 py-2.5  dark:bg-gray-800">
        <div className="flex flex-wrap justify-between items-center mx-auto max-w-[1620px]">
          <Link to="/" className="flex items-center">
            <img src={logo} className="mr-3 h-8 sm:h-12" alt="Logo" />
          </Link>
          <div className="flex items-center lg:order-2 ">
            <Link
              onClick={() => {
                toggle();
              }}
              to="#"
              className="text-gray-800 w-[95px]  focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:text-gray-400 dark:focus:ring-gray-800"
            >
              {toggler}
            </Link>
            {/* <span
              to="#"
              className={`"bg-primary-700 ${
                onlineStatus ? "bg-green-600" : "bg-red-500"
              }  hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-full text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"`}
            ></span> */}
            <div className="flex items-end dark:text-gray-400 justify-between w-[75px] ">
              <svg
                height="20"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                className={
                  onlineStatus
                    ? "drop-shadow-[0_0_6px_#5EFF09] text-[#5EFF09]"
                    : "drop-shadow-[0_0_6px_#ff0000] text-[red]"
                }
              >
                <circle
                  r="5"
                  cx="10"
                  cy="10"
                  fill={onlineStatus ? "#5EFF09" : "red"}
                />
              </svg>
              <span>{onlineStatus ? "Online" : "Offline"}</span>
            </div>

            <button
              data-collapse-toggle="mobile-menu-2"
              type="button"
              className="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="mobile-menu-2"
              aria-expanded="false"
              onClick={() => {
                ShowHamburger();
              }}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"></path>
              </svg>
              <svg
                className="hidden w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"></path>
              </svg>
            </button>
          </div>
          <div
            className={`" ${
              show ? " " : "hidden"
            } justify-between items-center w-full lg:flex lg:w-auto lg:order-1"`}
            id="mobile-menu-2"
          >
            <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
              {/* <li>
                     <Link to="#" className="block py-2 pr-4 pl-3 text-white rounded bg-primary-700 lg:bg-transparent lg:text-primary-700 lg:p-0 dark:text-white" aria-current="page">Home</Link>
                    </li> */}
              <li>
                <Link
                  to="/"
                  className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/About"
                  className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/Contact"
                  className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700"
                >
                  Contactus
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700"
                >
                  Services
                </Link>
              </li>
              <li
                onClick={() => {
                  console.log(dishData);
                }}
                onDrop={() => {
                  dispatch(addItem(dishData));
                  console.log("dropped");
                }}
                onDragOver={(e) => {
                  let event = e;
                  event.stopPropagation();
                  event.preventDefault();
                }}
              >
                <Link
                  to="/cart"
                  className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700"
                >
                  Cart ({cartItems.length})
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};
export default Header;
